import React from 'react';
import { saveOwner, getOwnerByID } from '../../../../networking/NetworkingOwners';
import { getCustomerByID, getCustomersAscendantsAndDescendants } from '../../../../networking/NetworkingCustomers';
import { getMainAddressByPersonID } from '../../../../networking/NetworkingAddresses';
import { searchInGlobalWatchLists } from '../../../../networking/NetworkingGlobalWatchListSearch';
import { getStyle } from '../../../../styles/styles';
import AlertBox from '../../../shared/AlertBox';
import LoadingBox from '../../../shared/LoadingBox';
import AddressForm from '../../addresses/AddressForm';
import AddOwnerInformationForm from './AddOwnerInformationForm';
import DynamicSelect from '../../../shared/DynamicSelect';
import { GlobalSystemParametersNames } from '../../../../constants/GlobalSystemParametersNames';


var style = getStyle();

export default class AddOwnerScreen extends React.Component {

    state = {
        ownerID       : 0,
        updateToken         : 0,
        isValidated         : true,
        isValidatedAddress  : true,
        ownerInfoErrors      : [],
        addressErrors       : [],
        notFirstLoad        : true,
        notFirstLoadOwner    : true,
        showAlert           : false,
        showAlertError      : false,
        showAlertSaveSuspicious: false,
        alertTitle          : '',
        alertMessage        : '',
        loading             : false,
        updateOwner   : false,
        pressedButton       : false,
        saveProperties      : false,
        saveTasks           : false,
        selectOwner          : {},
        viewHistory         : false,
        isClearAdd          : false,
        isClearOwner         : false,
        activeTab: "owner-information",
        //OBJ FILTERS
        objOwnerInfo         : {},
        objAddress          : null,
        objBankAccount      : {},

        objJson             : [],
        //Attachments
        showAttachmentsDialog : false,

        customerList:[],
        CustomerID:'',
        CustomerIDName:'',
        SelectedCustomerPersonID:'',
        customerInfoUsed : false,
        allowCreateOwnerFromCustomer: false,
        showAlertCopyCustomer:false

    }

    loadCustomersRelated = () =>{
        getCustomersAscendantsAndDescendants(this.props.customerID).then(
                    (response) => {
                        if(response.customers !== undefined){
                            for (let i = 0; i < response.customers.length; i++){
                                response.customers[i].name = response.customers[i].Customer;
                                response.customers[i].value = response.customers[i].CustomerId;
                            }
                        }
                        this.setState({customerList: response.customers });
                    }
        );
    }

    componentDidMount() {
        let allowCreateOwnerFromCustomer = localStorage.getItem(GlobalSystemParametersNames.CreateOwnerFromCustomer);
        this.setState({allowCreateOwnerFromCustomer: allowCreateOwnerFromCustomer});
        this.loadCustomersRelated();
    }

    componentDidUpdate(prevProps){
         if (prevProps.customerID !== this.props.customerID) {
            this.loadCustomersRelated();
         }
    }

    updatePage(ownerID, updateToken, updateTokenAddress, newOwner) {
        var objOwnerInfo = this.state.objOwnerInfo
        var objAdd = this.state.objAddress;
        let customerInfoUsed = false;
        getOwnerByID(ownerID, 1).then(
            (json) => {
                objOwnerInfo.ownerID = ownerID
                objOwnerInfo.updateToken = updateToken
                objAdd.AddressID = json.owner[0].Address[0].AddressID
                objAdd.UpdateToken = updateTokenAddress
                debugger
                if(json.owner[0].EntityType === 'C')
                {
                    customerInfoUsed = true;
                }

                this.setState({ objOwnerInfo: objOwnerInfo, objAddress: objAdd, objJson:json.owner, customerInfoUsed: customerInfoUsed })
            }
        );
    }

    handleBackLink() {
        this.props.updateFunctionOrigin();
        this.props.backLink();
    }

    handleClearFieldsClick() {
        this.setState({
            notFirstLoad: true,
            notFirstLoadOwner: true,
            showAlert: false,
            showAlertError: false,
            alertTitle: '',
            alertMessage: '',
            updateOwner: false,
            pressedButton: false,
            saveProperties: false,
            saveTasks: false,
            selectOwner: null,
            viewHistory: false,
            objOwnerInfo: {},
            objAddress: null,
            objBankAccount: {}
        }, () => this.props.isNewClearOwner())
    }

    returnButtonState() {
        this.setState({ pressedButton: false });
    }

    handleButtonSaveClick = async (e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        
        if (this.state.loading || this.state.pressedButton) {
            return;
        }

        this.setState({ pressedButton: true, loading: true });

        if (this.state.isValidated && this.state.isValidatedAddress) {
            if (this.state.objOwnerInfo.bypassValidation) {
                this.saveAll(false);
            } else {
                this.setState({ loading: true });
                const textToSearch = this.state.objOwnerInfo.ownerType === "Individual" ?
                    `${this.state.objOwnerInfo.firstName} ${this.state.objOwnerInfo.lastName}` : this.state.objOwnerInfo.companyName;
                try {
                    const globalListsResponse = await searchInGlobalWatchLists(textToSearch, 'Owner', 0);
                    this.setState({ loading: false });
                    if (globalListsResponse != null && globalListsResponse.MatchedWords.length === 0 && globalListsResponse.SourceNames.length === 0) {
                        this.saveAll(false);
                    } else if (globalListsResponse == null) {
                        this.saveAll(false);
                    } else {
                        this.setState({ loading: false, showAlertSaveSuspicious: true, alertTitle: 'Warning', alertMessage: 'Found Owner in Watch Lists. The Owner will be saved with status "Suspicious"' });
                    }
                } catch (error) {
                    this.setState({ loading: false, pressedButton: false });
                }
            }
        } else {
            this.setState({ pressedButton: false, loading: false }); // Reset so they can try again after fixing
            if (this.state.isValidated && !this.state.isValidatedAddress) {
                this.setState({
                    showAlertError: true,
                    alertMessage: 'Please fill all mandatory fields',
                    alertTitle: 'Error',
                    notFirstLoad: false
                });
            } else if (!this.state.isValidated && !this.state.isValidatedAddress) {
                this.setState({
                    showAlertError: true,
                    alertMessage: 'Please fill all mandatory fields',
                    alertTitle: 'Error',
                    notFirstLoadOwner: false,
                    notFirstLoad: false
                });
            } else {
                this.setState({
                    showAlertError: true,
                    alertMessage: 'Please fill all mandatory fields',
                    alertTitle: 'Error',
                    notFirstLoadOwner: false
                });
            }
        }
    }

    showAlertAfterPropertiesValidation = () => {
        this.setState({ showAlert: true});
    }

    saveAll(isSuspicious) {
        let UserID = localStorage.getItem('UserID');
        var objFilter = {
            OwnerID: 0,
            CustomerID: this.props.customerID,
            StatusOwner: isSuspicious ? 'Suspicious' : this.state.objOwnerInfo.status,
            OwnerType: this.state.objOwnerInfo.ownerType,
            BypassValidation: this.state.objOwnerInfo.bypassValidation,
            ExpiryByPassDate: this.state.objOwnerInfo.expiryByPassDate,
            Salutation: this.state.objOwnerInfo.salutation!==undefined?this.state.objOwnerInfo.salutation:'',
            Name: this.state.objOwnerInfo.companyName || '',
            FirstName: this.state.objOwnerInfo.firstName || '',
            LastName: this.state.objOwnerInfo.lastName || '',
            ShortName: this.state.objOwnerInfo.shortName || '',
            Email:this.state.objOwnerInfo.contactEmail || '',
            Phone: this.state.objOwnerInfo.contactPhone || '',
            ProcessStatus: '',
            UpdateToken: this.state.objOwnerInfo.updateToken,
            UserID: UserID,
            PersonID: this.state.objOwnerInfo.personID,

            Address: this.state.objAddress!==null?this.state.objAddress:{},
        }
        if (this.state.selectOwner != null) {
            if (this.state.selectOwner.Address != null) {
                objFilter.Address.AddressID = this.state.selectOwner.Address[0] != null ? this.state.selectOwner.Address[0].AddressID : (this.state.selectOwner.Address?.AddressID ?? 0)
            } else {
                objFilter.Address.AddressId = 0
            }
        } else {
            objFilter.Address.AddressId = 0
        }
        objFilter.Address.UpdateToken = this.state.objAddress != null ? this.state.objAddress.UpdateToken : undefined;
        objFilter.Address.UpdatedBy = UserID;
        objFilter.Address.PersonID = this.state.objOwnerInfo.personID;
        
        if (this.state.customerInfoUsed) {
            objFilter.Address = null;
        }
        
        this.setState({ selectOwner: objFilter });
        if ((this.state.objOwnerInfo.isEmailValid && this.state.objOwnerInfo.contactEmail !== '') || (!this.state.objOwnerInfo.isEmailValid && this.state.objOwnerInfo.contactEmail === '')) {
            this.setState({ loading: true });
            saveOwner(objFilter).then(
                (json) => {
                    if (json.httpStatusCode !== 200 && json.httpStatusCode !== 409) {
                        this.setState({ showAlertError: true, alertTitle: 'Error', alertMessage: json.httpErrorMessage || 'An error occurred while trying to save the owner. Please try again and complete the required fields(*).', loading: false, pressedButton: false });
                    } else if (json.httpStatusCode !== undefined && json.httpStatusCode === 409){
                        this.setState({ showAlertError: true, alertTitle: 'Error' , alertMessage: json.httpErrorMessage, loading: false, pressedButton: false });
                    } else {
                        this.setState(prevState => ({
                            selectOwner: {
                                ...prevState.selectOwner,
                                OwnerID: json.ownerID,
                                UpdateToken: json.updateToken
                            },
                            saveProperties: true,
                            saveTasks: true,
                            showAlert: true,
                            alertTitle: 'Success',
                            alertMessage: 'Owner successfully saved.',
                            loading: false
                        }), () => this.updatePage(json.ownerID, json.updateToken, json.updateTokenAddress, true));
                    }
                }
            ).catch(error => {
                this.setState({ loading: false, pressedButton: false, showAlertError: true, alertTitle: 'Error', alertMessage: 'An error occurred while trying to save.' });
            });
        } else {
            this.setState({ showAlertError: true, alertMessage: 'Your email is incorrect. Please try again.', alertTitle: 'Error', notFirstLoad: false, notFirstLoadOwner: false });
        }
    }
    isValidated = (validator) =>{
        if (validator.valid) {
            this.setState({
                isValidated: true,
                notFirstLoadOwner: true,
                ownerInfoErrors: []
            });
        } else {
            this.setState({
                isValidated: false,
                ownerInfoErrors: { tab: "Owner Information", errors: validator.errors }
            });
        }
    }
    isValidatedAddress = (validator) =>{
        if (validator.valid) {
            this.setState({
                isValidatedAddress: true,
                notFirstLoad: true,
                addressErrors: []
            });
        } else {
            this.setState({
                isValidatedAddress: false,
                addressErrors: { tab: "Address", errors: validator.errors }
            });
        }
    }

    handleViewHistoryClick() {
        this.setState({ viewHistory: true });
    }

    handleReturnToOwner() {
        this.setState({ viewHistory: false });
    }

    handleAttachmentsClick() {
        this.setState({
            showAttachmentsDialog: true
        });
    }

    closeAlert() {
        const dataToPass = (this.state.objJson && this.state.objJson[0]) ? this.state.objJson[0] : this.state.objOwnerInfo;
        this.setState({ showAlert: false, alertMessage: '', alertTitle: '', pressedButton: false }, () => this.props.selectedOwner(dataToPass));
    }
    closeAlertError() {
        this.setState({ showAlertError: false, alertMessage: '', alertTitle: '', notFirstLoadOwner: true, notFirstLoad: true, pressedButton: false, loading: false });
    }
    formatVisibilityNew(ownerID) {
        if (ownerID === '' || ownerID === null) { return "visible"; }
        else { return "hidden"; }
    }
    formatVisibilityUpdate(ownerID) {
        if (ownerID === '' || ownerID === null) { return "hidden"; }
        else { return "visible"; }
    }

    //OBJ FILTERS
    objFilterOwnerInfo(objFilter) {
        this.setState({ objOwnerInfo: objFilter });
    }

    objFilterOwnerAddress(objFilterA) {
        this.setState({ objAddress: objFilterA });
    }

    objFilterOwnerAddProperties(value) {
        this.setState({ saveProperties: value });
    }

    objFilterOwnerAddTasks(value) {
        this.setState({ saveTasks: value });
    }

    onClickTab = (tabName) => {
        this.setState({ activeTab: tabName });
    }

    formatVisibilityButton() {
        if (this.state.activeTab==="account-information") { return "hidden"; }
        else { return "visible"; }
    }

    onCloseAttachmentsDialog = ()=>
    {
        this.setState({
            showAttachmentsDialog: false,
        })
    }

    closeAlertSaveSuspicious = async () => {
        this.setState({ showAlertSaveSuspicious: false });
        // The locks are still active from handleButtonSaveClick
        await this.saveAll(true);
    }

    handleUpdateCustomerIDName = (value)=> {
        if (value.value !== undefined) {
            let customerIDName = value.name !== 'select' ? value.name : '';
            let customerID = value.value !== 'select' ? value.value : '';
            this.setState({CustomerIDName: customerIDName , CustomerID: customerID, SelectedCustomerPersonID: value.PersonID });
        }
    }

    handleUseInformationClick = async() =>{
        if(this.state.CustomerID !== '0' && this.state.CustomerID !== '' && this.state.SelectedCustomerPersonID !== '')
        {
            if (this.props.owners) {
                let exists = this.props.owners.find(b => b.PersonID === this.state.SelectedCustomerPersonID);
                if (exists) {
                    this.setState({alertTitle:'Error', alertMessage:"This customer has already been used.", showAlertCopyCustomer: true});
                    return true;
                }
            }

            let customerInfo = await getCustomerByID(this.state.CustomerID);
            if(customerInfo && customerInfo.CustomerID > 0)
            {
                let objFilter = {
                    ownerID: 0,
                    status: 'Pending activation',
                    ownerType: customerInfo.CustomerType === 'Individual' ? 'Individual' : customerInfo.CustomerType === 'Affilliate' ? 'Corporate' : customerInfo.CustomerType,
                    bypassValidation: customerInfo.BypassValidation,
                    contactEmail: customerInfo.Email,
                    contactPhone: customerInfo.Phone,
                    expiryByPassDate: customerInfo.ExpiryByPassDate,
                    salutation: (customerInfo.Salutation || '').trim(),
                    companyName: customerInfo.Name,
                    firstName: customerInfo.FirstName,
                    lastName: customerInfo.LastName,
                    shortName: customerInfo.ShortName,
                    personID: customerInfo.PersonID,
                    updateToken: '',
                    isEmailValid: true,
                    middleName: '', 
                    ownerRiskScore: '' 
                }

                let addressResponse = await getMainAddressByPersonID(customerInfo.PersonID);
                let address = Array.isArray(addressResponse) ? addressResponse[0] : addressResponse;

                let selectedAddress = null;
                if (address) {
                    selectedAddress = {
                        AddressId: address.AddressId,
                        AddressType: address.AddressType,
                        AddressValue: address.AddressValue,
                        Address2: address.Address2,
                        City: address.City,
                        ZipCode: address.ZipCode,
                        StateId: address.StateId,
                        StateName: address.StateName,
                        CountryId: address.CountryId ? address.CountryId.trim() : '',
                        CountryName: address.CountryName,
                        OtherState: address.OtherState,
                        DefaultAddress: true,
                        SinceWhen: address.SinceWhen,
                        Status: address.Status,
                        District: address.District,
                        POBox: address.POBox,
                        UpdateToken: address.UpdateToken
                    }
                }

                this.setState({ customerInfoUsed: true, objOwnerInfo: objFilter, objAddress: selectedAddress });
            }
        }
    }

    handleClearInformationClick = () =>{
        if(this.state.CustomerID !== '0' && this.state.CustomerID !== '')
        {
            let objFilter = {
                ownerID: 0,
                status:'',
                ownerType: '',
                bypassValidation: false,
                contactEmail: '',
                contactPhone: '',
                expiryByPassDate: '',
                salutation: '',
                companyName:'',
                firstName: '',
                lastName: '',
                shortName: '',
                middleName: '',
                personID: null,
                updateToken: '',
                isEmailValid: true,
                ownerRiskScore: ''
            }

            this.setState({customerInfoUsed: false, objOwnerInfo: objFilter, objAddress: null, SelectedCustomerPersonID: '', CustomerID:'', CustomerIDName:''});
        }
    }


    render() {
        return (
            <div>
                <div>
                    <ul uk-tab="">
                        <li>
                            <a href="#owner-information-tab" id="owner-information" onClick={() => this.onClickTab('owner-information')}>Owner Information</a>
                        </li>
                        <li>
                            <a href="#address-information-tab" id="address-information" onClick={() => this.onClickTab('address-information')}>Address</a>
                        </li>
                    </ul>
                    <ul className="uk-switcher uk-margin">
                      <li id="owner-information-tab">
                        {this.state.allowCreateOwnerFromCustomer && 
                            <div className="uk-grid" style={{marginBottom:'10px'}}>
                            <div className="uk-width-1-4 uk-form-stacked">
                                <label className="uk-form-label" htmlFor="form-deal-CustomerIDName">Customer</label>
                                <div className="" style={style.inputStyle}>
                                    <DynamicSelect className={'uk-select'} objValue={{ value: this.state.CustomerID, name: this.state.CustomerIDName }} getValue={this.handleUpdateCustomerIDName} listHasPlaceholder={false} placeholder={'Customer'} data={this.state.customerList} id="CustomerIDName" disabled={this.props.customerInfoUsed} />
                                </div>
                            </div>
                            <div className="uk-width-1-5 uk-form-stacked" style={{marginTop:'15px'}}>
                                <button className="uk-button uk-button-green uk-margin-right" onClick={this.handleUseInformationClick} type="button" disabled={this.state.customerInfoUsed}>Use Information</button>
                            </div>
                            <div className="uk-width-1-5 uk-form-stacked" style={{marginTop:'15px'}}>
                                <button className="uk-button uk-button-green uk-margin-right" onClick={this.handleClearInformationClick} type="button">Clear</button>
                            </div>
                            </div>
                        }
                            <AddOwnerInformationForm key={this.state.customerInfoUsed ? 'customer-info-used' : 'customer-info-unused'} isValid={this.isValidated.bind(this)} updateFunction={this.updatePage.bind(this)} customerName={this.props.customerName} objFilterOwnerInfo={this.objFilterOwnerInfo.bind(this)} notFirstLoad={this.state.notFirstLoadOwner} customerInfoUsed={this.state.customerInfoUsed} objOwner={this.state.objOwnerInfo} />
                      </li>
                        <li id="address-information-tab">
                             <AddressForm key={this.state.customerInfoUsed ? 'address-info-used' : 'address-info-unused'} clearFields = {this.props.isClearAdd} selectedAddress={this.state.objAddress} getAddressInfo={this.objFilterOwnerAddress.bind(this)} isValid={this.isValidatedAddress.bind(this)} validations={this.state.notFirstLoad} isCustomer = {false} customerInfoUsed={this.state.customerInfoUsed} />
                            {/*<OwnerAddressForm updateFunction={this.updatePage.bind(this)} selectedOwnerAddress={this.props.selectedOwner.Address}  ownerID={this.props.ownerID} objFilterOwnerAddress={this.objFilterOwnerAddress.bind(this)}/>*/}
                        </li>
                    </ul>
                </div>

                <div style={{visibility:this.formatVisibilityButton()}}>
                    {/* <button className="uk-button uk-button-green uk-margin-right" onClick={this.handleClearFieldsClick.bind(this)} type="button">Clear Fields</button> */}
                    <button className="uk-button uk-button-green uk-margin-right" onClick={this.handleButtonSaveClick} type="button" disabled={this.state.loading || this.state.pressedButton}>Save</button>
                    <button className="uk-button uk-button-green uk-margin-right" onClick={this.handleBackLink.bind(this)} type="button">Exit</button>
                </div>
                <AlertBox
                    open={this.state.showAlertCopyCustomer}
                    onClose={()=>this.setState({showAlertCopyCustomer:false})}
                    title={'Error'}
                    message={'This customer has already been used.'}
                    type="Ok"
                    okClick={()=>this.setState({showAlertCopyCustomer:false})}
                />
                <AlertBox
                    open={this.state.showAlert}
                    onClose={this.closeAlert.bind(this)}
                    title={this.state.alertTitle}
                    message={this.state.alertMessage}
                    type="Ok"
                    okClick={this.closeAlert.bind(this)}
                />
                <AlertBox
                    open={this.state.showAlertSaveSuspicious}
                    onClose={this.closeAlertSaveSuspicious}
                    title={this.state.alertTitle}
                    message={this.state.alertMessage} type="Ok" okClick={this.closeAlertSaveSuspicious} />
                <AlertBox
                    open={this.state.showAlertError}
                    onClose={this.closeAlertError.bind(this)}
                    title={this.state.alertTitle}
                    message={this.state.alertMessage}
                    type="Ok"
                    messageBoldList={[this.state.ownerInfoErrors, this.state.addressErrors]}
                    okClick={this.closeAlertError.bind(this)}
                />
                <LoadingBox loading={this.state.loading} />
            </div>
        );
    }
}